module.exports = __webpack_public_path__ + "img/56ne.255d92fc.svg";